import { AppEntities } from "../../../../config/entities";
import React from "react";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";
import { CatalogListView } from "../../../Shared/CatalogListView";
import { CatalogListViewToolbar } from "../../../Shared/ListViews/CatalogListViewToolbar";
import { CatalogListViewDefaultToolbarButtons } from "../../../Shared/ListViews/CatalogListViewDefaultToolbarButtons";

const DriverList = () => {
  const fields = [{ title: "Name", fieldName: "name" }];

  return (
    <>
      <CatalogListView fields={fields} entity={AppEntities.Driver}>
        <CatalogListViewToolbar>
          <CatalogListViewDefaultToolbarButtons />
        </CatalogListViewToolbar>
      </CatalogListView>{" "}
    </>
  );
};

export default DriverList;
